import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useCompany } from "../context/CompanyContext";
import { EmptyState, Money, PageHeader, TableSkeleton, fmtDate } from "../components/erp";

export default function CreditNotes() {
  const { activeId } = useCompany();
  const [data, setData] = useState(null);
  const nav = useNavigate();

  useEffect(() => {
    if (!activeId) return;
    setData(null);
    api.get("/credit-notes?limit=200").then((r) => setData(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [activeId]);

  return (
    <div data-testid="credit-notes-page">
      <PageHeader title="Credit Notes" testId="credit-notes-title"
        sub="Sales returns — restock items, reduce customer balance. Create from any posted invoice." />
      <div className="rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 overflow-hidden">
        {!data ? <TableSkeleton /> : data.items.length === 0 ? (
          <EmptyState testId="credit-notes-empty" title="No credit notes yet"
            body="Open a posted invoice and use 'Credit Note' to record a sales return."
            actionLabel="Go to Invoices" actionTo="/invoices" />
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm" data-testid="credit-notes-table">
              <thead><tr className="bg-slate-50 dark:bg-slate-800/60 text-left text-xs font-semibold uppercase tracking-wider text-slate-500">
                <th className="p-3">CN No</th><th className="p-3">Date</th><th className="p-3">Customer</th>
                <th className="p-3">Against Invoice</th><th className="p-3">Reason</th><th className="p-3 text-right">Amount</th></tr></thead>
              <tbody>
                {data.items.map((cn) => (
                  <tr key={cn.id} data-testid={`cn-row-${cn.doc_no}`}
                    className="border-b border-slate-100 dark:border-slate-800 hover:bg-slate-50/80 dark:hover:bg-slate-800/40">
                    <td className="p-3 font-mono text-xs font-semibold">{cn.doc_no}</td>
                    <td className="p-3">{fmtDate(cn.date)}</td>
                    <td className="p-3">{cn.party_name}</td>
                    <td className="p-3">
                      <button className="font-mono text-xs text-blue-600 hover:underline"
                        onClick={() => nav(`/invoices/${cn.invoice_id}`)}>{cn.invoice_no}</button>
                    </td>
                    <td className="p-3 text-slate-500 max-w-[200px] truncate">{cn.reason}</td>
                    <td className="p-3 text-right"><Money value={cn.total} className="font-semibold text-red-600" /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
      <p className="mt-2 text-xs text-slate-400">{data?.total ?? 0} credit notes</p>
    </div>
  );
}
